customElements.get("product-form") || customElements.define("product-form", class t extends HTMLElement {
    constructor() {
        super(), this.form = this.querySelector("form"), this.form.querySelector("[name=id]").disabled = !1, this.form.addEventListener("submit", this.onSubmitHandler.bind(this)), this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer"), this.submitButton = this.querySelector('[type="submit"]'), document.querySelector("cart-drawer") && this.submitButton.setAttribute("aria-haspopup", "dialog"), this.hideErrors = "true" === this.dataset.hideErrors
    }
    onSubmitHandler(t) {
        if (t.preventDefault(), "true" === this.submitButton.getAttribute("aria-disabled")) return;
        this.handleErrorMessage(), this.submitButton.setAttribute("aria-disabled", !0), this.submitButton.classList.add("loading"), this.querySelector(".loading-overlay__spinner").classList.remove("hidden");
        let e = fetchConfig("javascript");
        e.headers["X-Requested-With"] = "XMLHttpRequest", delete e.headers["Content-Type"];
        let r = new FormData(this.form);
        this.cart && (r.append("sections", this.cart.getSectionsToRender().map(t => t.id)), r.append("sections_url", window.location.pathname), this.cart.setActiveElement(document.activeElement)), e.body = r, fetch(`${routes.cart_add_url}`, e).then(t => t.json()).then(t => {
            if (t.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                    source: "product-form",
                    productVariantId: r.get("id"),
                    errors: t.errors || t.description,
                    message: t.message
                }), this.handleErrorMessage(t.description);
                let e = this.submitButton.querySelector(".sold-out-message");
                if (!e) return;
                this.submitButton.setAttribute("aria-disabled", !0), this.submitButton.querySelector("span").classList.add("hidden"), e.classList.remove("hidden"), this.error = !0;
                return
            }
            // if(t.handle == 'pro-cold-plunge'&& this.querySelector('[name="selling_plan"]').hasAttribute('checked')) {
            //     let data = {
            //         "id": 45956705157366,
            //         "quantity": 1,
            //         "selling_plan":3416162550
            //     };
            //     jQuery.ajax({
            //         type: 'POST',
            //         url: '/cart/add.js',
            //         data: data,
            //         dataType: 'json',
            //         success: function(response) {  
            //           console.log('Item added to cart successfully YES', response);
            //         },
            //         error: function(error) {
            //           console.error('Error adding item to the cart:', error);
            //         }
            //     });
            // }
            if (!this.cart) {
                // window.location = window.routes.cart_url;
                return
            }
            this.error || publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: r.get("id"),
                cartData: t
            }), this.error = !1;
            let s = this.closest("quick-add-modal");
            s ? (document.body.addEventListener("modalClosed", () => {
                setTimeout(() => {
                    this.cart.renderContents(t)
                })
            }, {
                once: !0
            }), s.hide(!0)) : this.cart.renderContents(t)
        }).catch(t => {
            console.error(t)
        }).finally(() => {
            this.submitButton.classList.remove("loading"), this.cart && this.cart.classList.contains("is-empty") && this.cart.classList.remove("is-empty"), this.error || this.submitButton.removeAttribute("aria-disabled"), this.querySelector(".loading-overlay__spinner").classList.add("hidden")
        })
    }
    handleErrorMessage(t = !1) {
        !this.hideErrors && (this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper"), this.errorMessageWrapper && (this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message"), this.errorMessageWrapper.toggleAttribute("hidden", !t), t && (this.errorMessage.textContent = t)))
    }
});